<div [formGroup]="parentForm" class="input-container">
    <mm-text-input-control [parentForm]="parentForm" [inputControlModel]="checkMemoModel"
        [useDirty]="true"></mm-text-input-control>
    <div id="checkMemo-messages">
        <div *ngIf="hasError" id="checkMemo-error-text" data-testid="checkMemo-error-text"
            class="alert-text">{{ checkMemoValidationError }}</div>
        <div id="character-count">{{checkMemoLength}}/{{checkMemoModel.htmlMaxLength}}</div>
    </div>
</div>
